




















































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import MergeSupplierTopOrgsTrigger from './MergeSupplierTopOrgsTrigger.coffee'

settings =
  name: 'MergeSupplierTopOrgsTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [MergeSupplierTopOrgsTrigger.trigger()]

    components: {
      Modal,
      RequestButton,
    }

    data: ->
      childOrgOptions: []
      childOrgsLoading: false

    computed:
      parentOrg: ->
        @modal.config.supplier || {}

    methods:
      modalData: ->
        child_org_id: null
        delete_child: true

      hiSearchChildOrgs: (text) ->
        @searchChildOrgs text

      searchChildOrgs: (value) ->
        @childOrgOptions = []
        @childOrgsLoading = true

        text = value?.trim() || ''
        orgs = await RecessAPI.search 'suppliers', { text, scope: 'top_org', per_page: 100 }
        options = for org in orgs
          continue if org.id is @parentOrg.id
          value: org.id
          label: org.name
          data: org
        options.sort((a, b) -> a.label.localeCompare b.label)

        @childOrgOptions = options
        @childOrgsLoading = false

    watch:
      'modal.show': (value) ->
        @searchChildOrgs() if value

export default VueOptions.vue settings
